import { PENDLE_PT_LOCK_TOKEN_IDS, TOKEN_IDS, type LockTokenId } from "@/types";

type LockTokenInputValidationRule = {
    matches: (tokenId: LockTokenId) => boolean;
    minAmount: number;
    getMessage: (tokenId: LockTokenId, minAmount: number) => string;
};

const LOCK_TOKEN_INPUT_VALIDATION_RULES: LockTokenInputValidationRule[] = [
    {
        matches: (tokenId) => tokenId === TOKEN_IDS.USDC,
        minAmount: 2e-6, // gateway contract reverts on 1e-6
        getMessage: (tokenId, minAmount) => `Minimum ${tokenId} lock amount is ${minAmount}.`,
    },
    {
        matches: (tokenId) => Object.hasOwn(PENDLE_PT_LOCK_TOKEN_IDS, tokenId),
        minAmount: 1,
        getMessage: (tokenId, minAmount) => `Minimum ${tokenId} lock amount is ${minAmount}.`,
    },
];

export function getLockTokenInputValidationError(tokenId: LockTokenId, amount: string | number): string | undefined {
    if (typeof amount === "string" && amount.trim() === "") {
        return undefined;
    }

    const parsedAmount = Number(amount);
    if (!Number.isFinite(parsedAmount)) return undefined;

    const applicableRule = LOCK_TOKEN_INPUT_VALIDATION_RULES.find((rule) => rule.matches(tokenId));
    if (!applicableRule) return undefined;
    if (parsedAmount < applicableRule.minAmount) {
        return applicableRule.getMessage(tokenId, applicableRule.minAmount);
    }

    return undefined;
}
